import { useCallback } from 'react';
import { getQpDomain } from 'utils/appOrigin';

export default function useLogout(): () => void {
  return useCallback(async () => {
    const qpDomain = getQpDomain();
    const reputationOrigin = window.location.origin;
    localStorage.clear();
    window.location.href = `${qpDomain}/a/logout.do?appOrigin=${encodeURIComponent(reputationOrigin)}`;
  }, []);
}
